import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ExportReport = ({ report, emirate, period }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = () => {
    if (!report) return;
    setExporting(true);
    setTimeout(() => {
      const content = [
        `UAE MARKET INTELLIGENCE REPORT`,
        `${emirate === 'all' ? 'All Emirates' : emirate} | ${period}`,
        `Generated: ${new Date()?.toLocaleDateString()}`,
        ``,
        `EXECUTIVE SUMMARY`,
        `=================`,
        report?.executiveSummary || '',
        ``,
        `KEY METRICS`,
        `-----------`,
        `Median Price: ${report?.metrics?.medianPrice || 'N/A'}`,
        `YoY Growth: ${report?.metrics?.yoyGrowth || 'N/A'}`,
        `Transactions: ${report?.metrics?.transactions || 'N/A'}`,
        `Price/sqft: ${report?.metrics?.pricePerSqft || 'N/A'}`,
        ``,
        `MARKET ANALYSIS`,
        `---------------`,
        report?.marketAnalysis?.summary || '',
        ``,
        `RERA/DLD REGULATORY UPDATES`,
        `---------------------------`,
        report?.reraUpdates?.summary || '',
        ``,
        `OFF-PLAN MARKET`,
        `---------------`,
        report?.offPlanUpdates?.marketOverview || '',
        ``,
        `EXPAT BUYING TRENDS`,
        `-------------------`,
        report?.expatTrends?.summary || '',
      ]?.join('\n');

      const blob = new Blob([content], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `UAE-Market-Intelligence-${emirate}-${period}.txt`;
      a?.click();
      URL.revokeObjectURL(url);
      setExporting(false);
    }, 800);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon name="Download" size={16} className="text-gray-600" />
          <div>
            <p className="text-sm font-semibold text-gray-900">Export Report</p>
            <p className="text-xs text-gray-500">Download for client presentations</p>
          </div>
        </div>
        <button
          onClick={handleExport}
          disabled={!report || exporting}
          className="flex items-center gap-2 bg-gray-900 hover:bg-gray-700 disabled:bg-gray-300 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
        >
          {exporting ? (
            <><div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" /> Exporting...</>
          ) : (
            <><Icon name="FileDown" size={14} /> Download Report</>
          )}
        </button>
      </div>
    </div>
  );
};

export default ExportReport;
